import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from 'react';
import merge from 'lodash/merge';
import hoistStatics from 'hoist-non-react-statics';
import wrapDisplayName from 'recompose/wrapDisplayName';
import SidebarState from '../_contexts/SidebarState';
import ConfigContext, { DEFAULT_CONFIG } from '../_contexts/ThemeConfig';

var withThemeProviders = function withThemeProviders(WrappedComponent) {
  var _Component = function _Component(_ref) {
    var config = _ref.config,
        compact = _ref.compact,
        otherProps = _objectWithoutProperties(_ref, ["config", "compact"]);

    var _config = merge({}, DEFAULT_CONFIG, config, {
      compact: compact
    });

    return React.createElement(ConfigContext.Provider, {
      value: _config
    }, React.createElement(SidebarState.Provider, null, React.createElement(WrappedComponent, otherProps)));
  };

  _Component.defaultProps = {
    compact: undefined,
    config: undefined
  };
  _Component.WrappedComponent = WrappedComponent;
  _Component.displayName = wrapDisplayName(WrappedComponent, 'withThemeProviders');
  hoistStatics(_Component, WrappedComponent);
  return _Component;
};

export default withThemeProviders;